import { DefaultService } from '@/services/DefaultService';

export default class MotivoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(motivo) {
        return this._http.post(`${this._env}/agro/motivo/updatesituacao`, 
            motivo, 
            this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAll(column, order, page, limit, situacao, params) {
        return this._http.get( encodeURI(`${this._env}/agro/motivo.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/agro/motivo/getcombo.json?param=${params}`), this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/motivo/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllOrigens() {
        return this._http.get(`${this._env}/agro/motivo/origens.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    save(form) {
        return this._http.post(`${this._env}/agro/motivo`, form, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}